import { observer } from "mobx-react-lite"

import { useLiquidityPageContext } from "@/domains/liquidity-page/context"
import { MinimalPoolStore } from "@/domains/minimal-pool"
import { ZapDialog } from "@/domains/minimal-pools-zap/components/zap-dialog"

interface ZapDialogPageProps {
  isOpen: boolean
  pool: MinimalPoolStore
  onClose: () => void
}

export const ZapDialogPage = observer(({ pool, isOpen, onClose }: ZapDialogPageProps) => {
  const { zapOrchestrator } = useLiquidityPageContext()
  const store = zapOrchestrator?.store

  // Defensive programming - handle undefined orchestrator or store
  if (!zapOrchestrator || !store) {
    console.error("ZapDialogPage: orchestrator or store is undefined", { zapOrchestrator, store })
    return null
  }

  // Set the pool when dialog opens
  if (isOpen && store.pool !== pool) {
    store.setPool(pool)
  }

  const handleApprove = () => {
    zapOrchestrator.approveZap()
  }

  const handleGetEstimate = () => {
    zapOrchestrator.startZapFlow()
  }

  const handleExecute = () => {
    zapOrchestrator.executeZap()
  }

  const handleRetryEstimate = () => {
    zapOrchestrator.retryEstimate()
  }
  const handleRetryApproval = () => {
    zapOrchestrator.retryApproval()
  }
  const handleRetryExecution = () => {
    zapOrchestrator.retryExecution()
  }

  const handleCancel = () => {
    zapOrchestrator.cancel()
    onClose()
  }

  const handleBackToIdle = () => {
    zapOrchestrator.backToIdle()
  }

  const handleReset = () => {
    zapOrchestrator.reset()
  }

  const handleClose = () => {
    zapOrchestrator.reset()
    onClose()
  }

  if (!isOpen) return null

  return (
    <ZapDialog
      store={store}
      poolName={pool.displayName}
      onApprove={handleApprove}
      onBackToIdle={handleBackToIdle}
      onClose={handleClose}
      onCancel={handleCancel}
      onExecute={handleExecute}
      onGetEstimate={handleGetEstimate}
      onReset={handleReset}
      onRetryEstimate={handleRetryEstimate}
      onRetryApproval={handleRetryApproval}
      onRetryExecution={handleRetryExecution}
      onZapCompleteClose={handleClose}
    />
  )
})
